import clsx from "clsx";
import React, { FunctionComponent, ReactNode } from "react";
import { useRoute } from "wouter";

import { useLanguage } from "../../i18n/useLanguage";
import { DealerVehicleResultsRoute } from "../../navigation/DealerRoutes";
import { useValidateVehicleKeys } from "../../queries/useValidateVehicleKeys";
import { Image } from "../../ui/Image/Image";
import { Placeholder } from "../../ui/Placeholder";
import { TireSizeOptions } from "./TireSizeOptions";

type VehicleHeaderProps = {
  children?: ReactNode;
  className?: string;
};

export const VehicleHeader: FunctionComponent<VehicleHeaderProps> = ({
  children,
  className,
}) => {
  const { data: keys } = useValidateVehicleKeys();
  const [language] = useLanguage();
  const [isVehicle] = useRoute(DealerVehicleResultsRoute);

  if (!isVehicle) {
    return <div className="py-2 md:py-4" />;
  }

  return (
    <div className={clsx("tw-vehicle-header", className)}>
      <figure className="tw-vehicle-header__figure">
        <Image
          alt="Vehicle Image"
          className="mix-blend-multiply"
          fallbackSrc="/static/img/placeholder_car.png"
          height={290}
          pulsate={!keys}
          src={keys?.vehicleSubmodelImage || keys?.vehicleModelImage}
        />
        <div>
          <h1>
            <Placeholder className="w-[12rem]" loading={!keys}>
              {keys?.vehicleManufacturerName}{" "}
              {keys?.vehicleSubmodelName[language as "en"]}
            </Placeholder>
          </h1>
          <h2>
            <Placeholder className="w-[8rem]" loading={!keys}>
              {keys?.vehicleManufacturerName} &ndash; {keys?.vehicleYearName}
            </Placeholder>
          </h2>
        </div>
      </figure>
      {children || <TireSizeOptions />}
    </div>
  );
};
